/**!
 * Created by Leonardo Cheslacki on 22/02/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 *
 * @type {{}}
 */
module.exports.main = {
    /**
     * Paths of src for compact min.
     */
    paths: [
        'index',
        'src/capa/capa',
        'src/ficha/ficha',
        'src/implantacoes/implantacao01/implantacao01',
        'src/implantacoes/implantacao02/implantacao02',
        'src/implantacoes/implantacao03/implantacao03',
        'src/orientacao/orientacao',
        'src/localizacao/localizacao',
        'src/projetistas/projetistas',
        'src/diferenciais/diferenciais',
        'src/galleryImagens/galleryImagens',
        'src/plantas/planta01/planta01',
        'src/plantas/planta02/planta02',
        'src/plantas/planta03/planta03',
        'src/plantas/planta04/planta04',
        'src/vistas/vistas',
		'src/rededor/rededor01/rededor01',
		'src/rededor/rededor02/rededor02',
		'src/rededor/rededor03/rededor03'
    ]
};

/**
 *
 * @type {{}}
 */
module.exports.menu = {
    /**
     * name: {string} Name of file FLA;
     * frame: {int} Number of frame, Ex: Label frame01 is default empty,
     * do you not use number '1' and yes the subsequent ones, corresponds to the 'name' of the FLA;
     * type: {string} Type of link 'video', 'tour', 'external', 'paginate' or 'audio';
     * uri: {string} URI or URL of 'type';
     * logo: {string} Size of logo 'none', 'small', 'medium' or 'large';
     * dynamic: {boolean} Layer "background_dynamic" changes from 'frame';
     * default: {string} Page default init;
     *
     * Marker changes from 'frame';
     * Occurrence btn_ execute the 'frame' correspondent, Ex: 'btn_page02' for 'frame02';
     */
    index: [
        {
            name: 'capa',
            frame: 2,
            uri: null,
            type: null,
            logo: 'none',
            dynamic: true,
            default: true
        },
        {
            name: 'ficha',
            frame: 3,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'implantacoes',
            frame: 4,
            uri: null,
            type: 'paginate',
            logo: 'large',
            dynamic: true,
            default: false,
            paginates: [
                {
                    name: 'implantacao01',
                    frame: 1,
                    uri: null,
                    type: null,
                    xml: 'implantation01.xml',
                    content_text: {
                        frame_01: {
                            A: 17,
                            B: 23
                        }
                    },
                    default: true
                },
                {
                    name: 'implantacao02',
                    frame: 2,
                    uri: null,
                    type: null,
                    xml: 'implantation02.xml',
                    content_text: {
                        frame_01: {
                            A: 13
                        }
                    },
                    default: false
                },
                {
                    name: 'implantacao03',
                    frame: 3,
                    uri: null,
                    type: null,
                    xml: 'implantation03.xml',
                    content_text: {
                        frame_01: {
                            A: 11
                        }
                    },
                    default: false
                }
            ]
        },
        {
            name: 'orientacao',
            frame: 5,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'localizacao',
            frame: 6,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'projetistas',
            frame: 7,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'diferenciais',
            frame: 8,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'galleryImagens',
            frame: 9,
            uri: null,
            type: null,
            logo: 'large',
            dynamic: true,
            default: false
        },
        {
            name: 'plantas',
            frame: 10,
            uri: null,
            type: 'paginate',
            logo: 'large',
            dynamic: true,
            default: false,
            paginates: [
                {
                    name: 'planta01',
                    frame: 1,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        camera: true
                    },
                    default: true
                },
                {
                    name: 'planta02',
                    frame: 2,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        camera: true
                    },
                    default: false
                },
                {
                    name: 'planta03',
                    frame: 3,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        camera: true
                    },
                    default: false
                },
                {
                    name: 'planta04',
                    frame: 4,
                    uri: null,
                    type: null,
                    active: {
                        differential: true,
                        camera: true
                    },
                    default: false
                }
            ]
        },
        // {
        //     name: 'vistas',
        //     frame: 11,
        //     uri: null,
        //     type: null,
        //     logo: 'large',
        //     dynamic: true,
        //     default: false
        // },
        // {
        //     name: 'video',
        //     frame: 12,
        //     uri: 'https://thegrand.interativo.app.br/public/media/vr-girl.mp4',
        //     type: 'video',
        //     logo: 'large',
        //     dynamic: true,
        //     default: false
        // }
		
		{
            name: 'rededor',
            frame: 13,
            uri: null,
            type: 'paginate',
            logo: 'large',
            dynamic: true,
            default: false,
            paginates: [
                {
                    name: 'rededor01',
                    frame: 1,
                    uri: null,
                    type: null,
                    default: true
                },
                {
                    name: 'rededor02',
                    frame: 2,
                    uri: null,
                    type: null,
                    xml: 'implantationDor02.xml',
                    content_text: {
                        frame_01: {
                            A: 11
                        }
                    },
                    default: false
                },
                {
                    name: 'rededor03',
                    frame: 3,
                    uri: null,
                    type: null,
                    xml: 'implantationDor03.xml',
                    content_text: {
                        frame_01: {
                            A: 11
                        }
                    },
                    default: false
                }
				
            ]
        }
    ]
};

/**
 *
 * @type {{}}
 */
module.exports.game = {
    /**
     * Pseudos buttons.
     */
    pseudos: ['unvisited', 'hover', 'active']
};

/**
 *
 * @type {{}}
 */
module.exports.memory = {
    /**
     * Pseudos buttons.
     */
    pseudos: ['effect', 'unvisited', 'hover', 'active']
};

/**
 *
 * @type {{}}
 */
module.exports.default = {
    name: 'AllTap',
    description: 'App Interactive',
    app_name: 'PADRE ADELINO',
    domain: 'https://thegrand.interativo.app.br',
    timezone: 'America/Sao_Paulo',
    locale: 'pt',
    api: {
        ajax_setup_headers: {
            'Authorization': 'Bearer 10|XQ9Fp64YNrPE1I73zEpGdxjy1ZaZHXL6a895fRoZ'
        },
        url: 'http://gerenciador.local/api'
    },
    audio: {
        loop: true,
        all: true
    },
    video: {
        current_time: 0,
        thumbnail_time: 5
    },
    text: {
        font: 'MontserratRegular',
        weight: 'normal'
    },
    button: {
        color_icon: '0xEF3C3F'
    },
    fullscreen: {
        /**
         * fullscreen or audio
         */
        type: 'fullscreen',
        size: {
            width: 'auto',
            height: 300
        },
        logo: 'icons/favicon-white.png',
        confirm: {
            disabled: false,
            text: 'Visualizar em tela cheia',
            // text: 'Ativar áudio',
            class: 'btn-default'
        },
        cancel: {
            disabled: false,
            text: 'Não, obrigado',
            class: 'btn-default'
        },
        /**
         * https://github.com/craftpip/jquery-confirm
         */
        options: {
            content: false,
            theme: 'supervan',
            closeIcon: false,
            animation: 'scale',
            draggable: false
        }
    },
    iframe: {
        size: {
            width: 1920,
            height: 1000,
        },
        attributes: {
            allowfullscreen: '0',
            scrolling: 'no',
            frameborder: '0'
        }
    },
    external: {
        size: {
            width: 800,
            height: 600
        },
        attributes: {
            toolbar: '0',
            location: '0',
            menubar: '0'
        }
    },
    gallery: {
        xml: 'gallery.xml',
        /**
         * https://github.com/Splidejs/splide
         */
        options: {
            type: 'loop',
            focus: 'center',
            pagination: false,
            perPage: 1,
            arrows: false
        }
    },
    implantation: {
        xml: 'implantation.xml',
        pin: {
            number_x: null,
            number_y: -7.2,
            color_enabled: '0x000000',
            color_disabled: '0xCCCCCC',
            color_round: '0x9e9e9e'
        },
        text: {
            text_x: 140,
            text_y: 35,
            color_number: '0xFFFFFF',
            color_text: '0x231F20',
            font_size: 15,
            capitalize: true
        },
        modal: {
            scale: 0.7,
            composition_name: 'capa',
            padding_vertical: 10,
            padding_horizontal: 7,
            color_text: '0xFFFFFF',
            color_symbol: '0x000000'
        },
        content_text: {
            frame_01: {
                A: 5,
                B: 21,
                C: 34
            }
        }
    },
    scroll: {
        xml: 'scroll.xml',
        friction: 0.8,
        pin: {
            number_x: null,
            number_y: -7.2,
            color_enabled: '0x000000',
            color_disabled: '0xCCCCCC',
            color_round: '0xFFFFFF'
        },
        text: {
            text_x: 140,
            text_y: 34,
            color_number: '0xFFFFFF',
            color_text: '0xFFFFFF',
            font_size: 16,
            capitalize: false
        },
        modal: {
            scale: 0.7,
            composition_name: 'capa'
        },
        content_text: {
            frame_01: {
                A: 32
            }
        }
    },
    select: {
        friction: 0.8,
        text: {
            text_x: 140,
            text_y: 45,
            color_enabled: '0x333333',
            color_disabled: '0xAABBC0',
            font_size: 25,
            capitalize: false
        }
    },
    orientation: {
        speed: 2,
        slide: {
            color_title: '0x231F20',
            color_line: '0x231F20',
            color_arrow: '0x231F20',
            color_round: '0x231F20',
            color_circle: '0x08519D'
        },
        hours: {
            start: 6,
            end: 18
        },
        stations: [
            {
                month: 1,
                day: null
            },
            {
                month: 2,
                day: null
            },
            {
                month: 3,
                day: 20
            },
            {
                month: 4,
                day: null
            },
            {
                month: 5,
                day: null
            },
            {
                month: 6,
                day: 20
            },
            {
                month: 7,
                day: null
            },
            {
                month: 8,
                day: null
            },
            {
                month: 9,
                day: 22
            },
            {
                month: 10,
                day: null
            },
            {
                month: 11,
                day: null
            },
            {
                month: 12,
                day: 21
            }
        ],
        degrees: {
            autumn: 13,
            winter: 19,
            spring: 13,
            summer: 8
        }
    },
    view: {
        xml: 'view.xml',
        frame: 1,
        pav: 1,
        text: {
            color_text: '0xFFFFFF',
            font_size: 18,
            text_x: null,
            text_y: 5
        },
    },
    routes: {
        web: {
            public_path: 'public',
            uri_css: 'public/css',
            uri_js: 'public/js',
            uri_images: 'public/images',
            uri_images_animate: 'public/images/animate',
            uri_xml: 'public/xml',
            uri_src: 'src',
            uri_cover: 'capa/capa'
        }
    },
    init: {
        fullscreen: false,
        before: false,
        /**
         * Single, compiler --min-resources=all
         */
        single: false,
        gallery: false,
        frame: 1,
        marker: true
    }
};

/**
 *
 * @param responsive_active Allow replies, 'true' or 'false'.
 * @param responsive_replies Replies by, 'width', 'height' or 'both'.
 * @param scale_active Scale to fill visible area, 'true' or 'false'.
 * @param scale_type Adjust in display 'center' or stretch to fit 'stretch', "1 or 2".
 * @param dom_containers Array containers resize, 'elements'.
 */
module.exports.make = {
    responsive_active: true,
    responsive_replies: 'both',
    scale_active: false,
    scale_type: 1
};
